<template>
  <div class="d-flex flex-column flex">
    <loader v-if="authLoading"/>

    <div class="p-3 p-md-5">
      <div class="card p-0 col-lg-8 offset-lg-2">
        <div class="row no-gutters">
          <div class="col-md-6 r-l" style="">
            <div class="d-flex flex-column h-100">
              <h4 class="m-4 mb-3 text-black">{{ app_name }}</h4>
              <div class="d-flex flex align-items-center justify-content-center">
                <img class="login-logo" src="@/assets/logo_2026.svg" width="100%" :alt="$t('message.title')">
              </div>
            </div>
          </div>

          <div class="col-md-6 text-center" id="content-body" v-if="production">
            <b-button @click="signInWithOauth" variant="primary" class="mt-5">{{ $t('message.Login.signInWithEANM') }}</b-button>
          </div>

          <div class="col-md-6" id="content-body" v-if="development">
            <div class="p-4">
              <h5>{{ $t('message.Login.welcome') }}</h5>
              <p>
                <small class="text-muted">{{ $t('message.Login.info') }}</small>
              </p>
              <form @submit.prevent="login">
                <b-form-input v-model="email"
                              type="text"
                              placeholder="Enter email"
                              v-validate="'required|email'"
                              data-vv-name="email"
                              class="mb-4"
                ></b-form-input>

                <b-form-input v-model="password"
                              type="password"
                              placeholder="Enter password"
                              v-validate="'required'"
                              data-vv-name="password"
                              class="mb-4"
                ></b-form-input>

                <b-alert v-if="loginError" show variant="danger">{{ $t('message.Login.badCredentials') }}</b-alert>

                <b-button
                    variant="primary"
                    type="submit"
                    class="w-100"
                >{{ $t('message.Login.signIn') }}
                </b-button>

                <b-row class="mt-2">
                  <b-col class="mt-2">
                    <b-button v-if="vueAppLoginAsGuidelinesAndPublicationsCouncil"
                              variant="info"
                              type="button"
                              class="w-100"
                              @click="loginGuidelinesAndPublicationsCouncil"
                    >{{ $t('message.Login.signInAsGuidelinesAndPublicationsCouncil') }}
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="mt-2">
                  <b-col class="mt-2">
                    <b-button v-if="vueAppLoginAsSubmitter"
                              variant="warning"
                              type="button"
                              class="w-100"
                              @click="loginSubmitter"
                    >{{ $t('message.Login.signInAsSubmitter') }}
                    </b-button>
                  </b-col>
                </b-row>

<!--                <b-row class="mt-2" v-if="vueAppLoginAsAuthor">-->
<!--                  <b-col class="mt-2">-->
<!--                    <b-button-->
<!--                        variant="info"-->
<!--                        type="button"-->
<!--                        class="w-100"-->
<!--                        @click="loginAuthor"-->
<!--                    >{{ $t('message.Login.signInAsAuthor') }}-->
<!--                    </b-button>-->
<!--                  </b-col>-->
<!--                </b-row>-->

<!--                <b-row class="mt-2" v-if="vueAppLoginAsCoWriter">-->
<!--                  <b-col class="mt-2">-->
<!--                    <b-button-->
<!--                        variant="success"-->
<!--                        type="button"-->
<!--                        class="w-100"-->
<!--                        @click="loginCoWriter"-->
<!--                    >{{ $t('message.Login.signInAsCoWriter') }}-->
<!--                    </b-button>-->
<!--                  </b-col>-->
<!--                </b-row>-->

                <b-row class="mt-2" v-if="vueAppLoginAsReviewer">
                  <b-col class="mt-2">
                    <b-button
                        variant="danger"
                        type="button"
                        class="w-100"
                        @click="loginReviewer"
                    >{{ $t('message.Login.signInAsReviewer') }}
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="mt-2" v-if="vueAppLoginAsReviewer2">
                  <b-col class="mt-2">
                    <b-button
                        variant="danger"
                        type="button"
                        class="w-100"
                        @click="loginReviewer2"
                    >{{ $t('message.Login.signInAsReviewer2') }}
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="mt-2" v-if="vueAppLoginAsNDelegate">
                  <b-col class="mt-2">
                    <b-button
                        variant="dark"
                        type="button"
                        class="w-100"
                        @click="loginNationalDelegate"
                    >{{ $t('message.Login.signInAsNDelegate') }}
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="mt-2" v-if="vueAppLoginAsNDelegate2">
                  <b-col class="mt-2">
                    <b-button
                        variant="dark"
                        type="button"
                        class="w-100"
                        @click="loginNationalDelegate2"
                    >{{ $t('message.Login.signInAsNDelegate2') }}
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="mt-2">
                  <b-col class="mt-2">
                    <b-button v-if="vueAppLoginAsIGO"
                              variant="info"
                              type="button"
                              class="w-100"
                              @click="loginInternalGroupsOfficer"
                    >{{ $t('message.Login.signInAsIgo') }}
                    </b-button>
                  </b-col>
                </b-row>

                <b-row class="mt-2">
                  <b-col class="mt-2">
                    <b-button
                        variant="light"
                        type="button"
                        class="w-100"
                        @click="signInWithOauth"
                    >{{ $t('message.Login.signInWithOauth') }}
                    </b-button>
                  </b-col>
                </b-row>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import {AUTH_REQUEST, AUTH_LOGIN_WITH_CODE} from '@/store/actions/auth'
import {SHOW_WELCOME_DIALOG} from '@/store/actions/welcome_dialog'
import {mapState} from 'vuex'

export default {
  name: 'login',
  components: {},
  props: [],
  data() {
    return {
      email: process.env.VUE_APP_LOGIN ? process.env.VUE_APP_LOGIN : '',
      password: process.env.VUE_APP_PASSWORD ? process.env.VUE_APP_PASSWORD : '',
      app_name: process.env.VUE_APP_TITLE,

      vueAppLoginAsCommittee: process.env.VUE_APP_LOGIN_AS_COMMITTEE ? process.env.VUE_APP_LOGIN_AS_COMMITTEE : false,
      vueAppLoginAsGuidelinesAndPublicationsCouncil: process.env.VUE_APP_LOGIN_AS_GPC ? process.env.VUE_APP_LOGIN_AS_GPC : false,
      vueAppLoginAsSubmitter: process.env.VUE_APP_LOGIN_AS_SUBMITTER ? process.env.VUE_APP_LOGIN_AS_SUBMITTER : false,
      vueAppLoginAsAuthor: process.env.VUE_APP_LOGIN_AS_AUTHOR ? process.env.VUE_APP_LOGIN_AS_AUTHOR : false,
      vueAppLoginAsCoWriter: process.env.VUE_APP_LOGIN_AS_COWRITER ? process.env.VUE_APP_LOGIN_AS_COWRITER : false,
      vueAppLoginAsReviewer: process.env.VUE_APP_LOGIN_AS_REVIEWER ? process.env.VUE_APP_LOGIN_AS_REVIEWER : false,
      vueAppLoginAsReviewer2: process.env.VUE_APP_LOGIN_AS_REVIEWER2 ? process.env.VUE_APP_LOGIN_AS_REVIEWER2 : false,
      vueAppLoginAsNDelegate: process.env.VUE_APP_LOGIN_AS_NDELEGATE ? process.env.VUE_APP_LOGIN_AS_NDELEGATE : false,
      vueAppLoginAsNDelegate2: process.env.VUE_APP_LOGIN_AS_NDELEGATE2 ? process.env.VUE_APP_LOGIN_AS_NDELEGATE2 : false,
      vueAppLoginAsIGO: process.env.VUE_APP_LOGIN_AS_IGO ? process.env.VUE_APP_LOGIN_AS_IGO : false,
    }
  },

  computed: {
    loggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
    ...mapState({
      authLoading: state => state.auth.status === 'loading',
      loginError: state => state.auth.status === 'error',
    }),

    development() {
      return process.env.NODE_ENV === 'development'
    },

    production() {
      return process.env.NODE_ENV === 'production'
    }
  },

  mounted() {
    this.$store.dispatch(SHOW_WELCOME_DIALOG, true);

    if (!this.isAuthenticated && this.$route.query.code) {
      this.loginWithCode(this.$route.query.code);
    }

    if (this.isAuthenticated && this.$route.path !== '/') {
      if (this.$route.path !== '/') {
        this.$router.push('/');
      }
      ;
    }
  },

  methods: {
    login() {
      const {email, password} = this

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },

    loginWithCode(code) {
      this.$store.dispatch(AUTH_LOGIN_WITH_CODE, code).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      }).catch(() => {
        this.$swal({
          title: this.$t("message.forbidden"),
          text: this.$t("message.Login.badCredentials"),
          type: 'warning',
          showCancelButton: false,
        });

        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },

    loginCommittee() {
      const email = process.env.VUE_APP_COMMITTEE_LOGIN;
      const password = process.env.VUE_APP_COMMITTEE_PASS;

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },

    loginGuidelinesAndPublicationsCouncil() {
      const email = process.env.VUE_APP_GPC_LOGIN;
      const password = process.env.VUE_APP_GPC_PASS;

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },

    loginSubmitter() {
      const email = process.env.VUE_APP_SUBMITTER_LOGIN;
      const password = process.env.VUE_APP_SUBMITTER_PASS;

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },

    loginAuthor() {
      const email = process.env.VUE_APP_AUTHOR_LOGIN;
      const password = process.env.VUE_APP_AUTHOR_PASS;

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },

    loginCoWriter() {
      const email = process.env.VUE_APP_COWRITER_LOGIN;
      const password = process.env.VUE_APP_COWRITER_PASS;

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },

    loginReviewer() {
      const email = process.env.VUE_APP_REVIEWER_LOGIN;
      const password = process.env.VUE_APP_REVIEWER_PASS;

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },


    loginReviewer2() {
      const email = process.env.VUE_APP_REVIEWER2_LOGIN;
      const password = process.env.VUE_APP_REVIEWER2_PASS;

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },

    loginNationalDelegate() {
      const email = process.env.VUE_APP_NDELEGATE_LOGIN;
      const password = process.env.VUE_APP_NDELEGATE_PASS;

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },

    loginNationalDelegate2() {
      const email = process.env.VUE_APP_NDELEGATE2_LOGIN;
      const password = process.env.VUE_APP_NDELEGATE2_PASS;

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },

    loginInternalGroupsOfficer() {
      const email = process.env.VUE_APP_IGO_LOGIN;
      const password = process.env.VUE_APP_IGO_PASS;

      this.$store.dispatch(AUTH_REQUEST, {email, password}).then(() => {
        if (this.$route.path !== '/') {
          this.$router.push('/');
        }
      });
    },
    signInWithOauth() {
      window.location = process.env.VUE_APP_OAUTH_URL + 'oauth2/authorize?response_type=code&client_id=' + process.env.VUE_APP_OAUTH_CLIENT_ID + '&redirect_uri=' + process.env.VUE_APP_URL + '&scope=Api%2FUser';
    }
  },
}
</script>


<style scoped lang="scss">
.login-logo {
  max-width: 300px;
}
</style>
